import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaClipboardCheck } from "react-icons/fa6";
import TimeCard from "./index";
import ViewTimeCard from "./view";
import EditTimeCard from "./edit";
import { MODULE_TIMECARDS } from "variables/constants";

const timeCardsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Time Card",
		basePath: "time-cards",
		mainComponent: <TimeCard />,
	    layout: "/console",	   
	    icon: <FaClipboardCheck className="icon-item" />,
	    subTitle:"Time Card",
	    viewComponent: <ViewTimeCard />,
	    createComponent: <EditTimeCard />,
	    editComponent: <EditTimeCard />,
		level:5,
		moduleId: MODULE_TIMECARDS,
	})
]

export default timeCardsRoutes;